import ShareModuleDialogService from '@/components/dialogs/ShareModuleDialog/share-module-dialog-service';
import router from '@/router';
import store from '@/store';
import { getWorkflow } from '@/store/modules/workflows/getters';
import { selectedProjectId } from '@/store/modules/selectedProject/getters';
import { openSuggestionsToMoveCredentialsToUserConfiguration } from '@/store/modules/credentials/actions';
import { setLeftSideDrawerState } from '@/store/modules/leftSideDrawer/actions';
import { DRAWER_MODES } from '@/store/modules/leftSideDrawer/state';

/* Private */
function applyGetWorkflow(workflowId) {
	const getters = store.getters;
	return getters[getWorkflow.fullPath](workflowId);
}
function applyGetProjectId() {
	return store.getters[selectedProjectId.fullPath];
}

function applyOpenSuggestionsToMoveCredentialsToUserConfiguration(payload) {
	return store.dispatch(openSuggestionsToMoveCredentialsToUserConfiguration.fullPath, payload);
}

function applySetLeftSideDrawerState(payload) {
	return store.dispatch(setLeftSideDrawerState.fullPath, payload);
}

/* Public */

async function openShareModuleDialog(workflowId, canShare, openDialogCallback) {
	const workflow = applyGetWorkflow(workflowId);

	const res = await ShareModuleDialogService.openDialog(
		workflow,
		canShare,
		applyOpenSuggestionsToMoveCredentialsToUserConfiguration,
		workflow.flow_type,
		workflow.context_service_slug,
		openDialogCallback
	);
	if (res === 'should_open_general_setup') {
		const projectId = applyGetProjectId();
		router.push({ name: 'Feature', params: { wfID: workflowId, pID: projectId } });
		applySetLeftSideDrawerState(DRAWER_MODES.test);
	}

	return res;
}

const ShareModuleBridge = {
	openShareModuleDialog,
};

export default ShareModuleBridge;
